import type { CartExperimentParseResult, CartExperimentPolicy, CartExperimentValue } from './types';

export type {
  CartCouponPolicy,
  CartExperience,
  CartExperimentFallbackReason,
  CartExperimentParseResult,
  CartExperimentPolicy,
  CartExperimentSource,
  CartExperimentState,
  CartExperimentValue,
} from './types';

/** 仅解析原始策略值；不做 Number/trim 等隐式宽松转换，也不替调用方降级。 */
export function parseCartExperimentValue(raw: unknown): CartExperimentParseResult {
  switch (raw) {
    case 1:
    case '1':
      return { status: 'valid', value: 1 };
    case 2:
    case '2':
      return { status: 'valid', value: 2 };
    case 3:
    case '3':
      return { status: 'valid', value: 3 };
    case 4:
    case '4':
      return { status: 'valid', value: 4 };
    default:
      return { status: 'invalid' };
  }
}

/** 非法调用直接报错，既保证穷尽检查，也避免运行时绕过类型后误分组。 */
function rejectInvalidCartExperimentValue(_value: never): never {
  throw new RangeError('Invalid cart experiment value');
}

/** 只接受已解析的数字组号；每次返回独立对象，不维护第二份可变策略状态。 */
export function getCartExperimentPolicy(value: CartExperimentValue): CartExperimentPolicy {
  switch (value) {
    case 1:
      return { experience: 'legacy', couponPolicy: 'manual' };
    case 2:
      return { experience: 'legacy', couponPolicy: 'automatic' };
    case 3:
      return { experience: 'v1', couponPolicy: 'manual' };
    case 4:
      return { experience: 'v1', couponPolicy: 'automatic' };
    default:
      return rejectInvalidCartExperimentValue(value);
  }
}
